/**
 * Shared dial-code helpers for GET /country (checkout guest form, auth modal).
 */

export const FALLBACK_COUNTRY_CODES = [
  { code: "+91", name: "India" },
  { code: "+971", name: "United Arab Emirates" },
  { code: "+1", name: "USA" },
  { code: "+44", name: "UK" },
];

export const normalizeCountryCode = (raw) => {
  const value = String(raw || "").trim();
  if (!value) return "";
  return value.startsWith("+") ? value : `+${value}`;
};

export const extractCountryCode = (countryItem) =>
  normalizeCountryCode(
    countryItem?.phone_code ||
      countryItem?.country_code ||
      countryItem?.dial_code ||
      countryItem?.code
  );

/** @returns {{ code: string, name: string }[]} */
export const mapCountryRecordsToDialOptions = (rawCountries) => {
  const mapped = rawCountries
    .map((item) => ({
      code: extractCountryCode(item),
      name: item?.name || item?.country_name || "",
    }))
    .filter((item) => item.code);
  return Array.from(new Map(mapped.map((item) => [item.code, item])).values());
};

/**
 * Prefer UAE (+971) when present; else first option; else +971.
 */
export const pickDefaultDialCode = (dialOptions) => {
  if (!dialOptions?.length) return "+971";
  const uae = dialOptions.find(
    (o) =>
      o.code === "+971" ||
      /971/.test(o.code) ||
      /uae|united arab emirates/i.test(String(o.name || ""))
  );
  return uae?.code || dialOptions[0].code;
};

/**
 * Fetch /country and return raw list + deduped dial options.
 */
export const fetchCountryDialData = async (AppInstance) => {
  const { data } = await AppInstance.get("/country");
  const rawCountries = Array.isArray(data?.data)
    ? data.data
    : Array.isArray(data)
      ? data
      : [];
  const dialOptions = mapCountryRecordsToDialOptions(rawCountries);
  return { rawCountries, dialOptions };
};
